module.exports = __webpack_public_path__ + "media/images/fr_flag-a0af8005a44e29f692a7d5b793c0c541.png";